import { MsalProvider } from "@azure/msal-react"
import { PublicClientApplication, EventType } from "@azure/msal-browser"
import { AuthenticationResult } from "@azure/msal-common";

import { msalConfig } from "./auth-config"
import { useContext } from "react"
import { EnvContext } from "../env"

const Auth = (props: any) => {
    const { children } = props
    
    const env = useContext(EnvContext)
    const msalInstance = new PublicClientApplication(msalConfig(env))
        
    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    msalInstance.enableAccountStorageEvents();

    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
        if (event && event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    )

}

export default Auth
